import { useState } from "react";

import './Select.css';

import { Svg_Arrow } from "../Svg";
import { ICountry } from "../../fixedData";

// Opção padrão do select ({ value, label }), usada por company e type register.
// O id é number por padrão, mas os filtros de relatório usam texto (nome do
// país, região, cidade...), por isso o tipo é parametrizado.
export interface SelectOption<T extends string | number = number> {
    value        : T;
    label        : string;
    qtd_project? : number;
}

// Item da lista que alimenta o select padrão
export interface SelectItem<T extends string | number = number> {
    id           : T;
    name         : string;
    qtd_project? : number;
}

interface PropsDefault<T extends string | number> {
    title      : string;
    type?      : undefined;
    list       : SelectItem<T>[];
    value      : SelectOption<T>;
    setValue   : (value: SelectOption<T>) => void;
    required?  : boolean;
    className? : string;
    mask?      : (value: string) => string;
}

interface PropsCountry {
    title      : string;
    type       : "country";
    list       : ICountry[];
    value      : ICountry;
    setValue   : (value: ICountry) => void;
    required?  : boolean;
    className? : string;
    mask?      : (value: string) => string;
}

type Props<T extends string | number> = PropsDefault<T> | PropsCountry;

export default function Comp_Select<T extends string | number = number>(props: Props<T>) {

    const [ status, setStatus ] = useState(false);
    const [ search, setSearch ] = useState("");

    // Termo normalizado, usado para filtrar a lista de opções
    const searchTerm = search.trim().toLowerCase();

    function OpenSelect(){
        setSearch("");
        setStatus(true);
    }

    function CloseSelect(){
        setSearch("");
        setStatus(false);
    }

    // Filtra os países por sigla ou nome
    function ShowListCountry(list: ICountry[]){
        if(searchTerm === ""){
            return list;
        }
        return list.filter((elem)=>{
            return ( elem.sigla + ' - ' + elem.name ).toLowerCase().includes(searchTerm);
        });
    }

    // Filtra a lista padrão pelo nome
    function ShowListDefault(list: SelectItem<T>[]){
        if(searchTerm === ""){
            return list;
        }
        return list.filter((elem)=>{
            return elem.name.toLowerCase().includes(searchTerm);
        });
    }

    function ShowNameOpt(){
        if(props.type === "country"){
            if(props.value.sigla){
                return props.value.sigla + ' - ' + props.value.name;
            }
            return props.value.name;
        }

        if(props.mask){
            return props.mask(props.value.label);
        }
        return props.value.label;
    }

    return(
        <div className={ props.className ? "Comp_Select " + props.className : "Comp_Select" }>
            <div className={ status ? "name_input name_focus" : "name_input" }>
                { props.title }
            </div>

            <div className={ status ? "opt_selected div_focus" : "opt_selected" } onClick={ ()=>{ OpenSelect(); } }>
                { ShowNameOpt() }
            </div>

            <Svg_Arrow className={ status ? "icons icons_active" : "icons" } color={ status ? "#ffffff" : "#737574" } />

            {
                status ?
                    <>
                        <div className="list_opt">
                            <div className="search_opt">
                                <input
                                    type="text"
                                    value={ search }
                                    onChange={ (e)=>{ setSearch(e.target.value); } }
                                    placeholder="Search"
                                    autoFocus
                                />
                            </div>

                            {
                                props.type === "country" ?
                                    ShowListCountry(props.list).map((elem, index)=>{
                                        return(
                                            <div className="opt_name" key={ index } onClick={ ()=>{ props.setValue(elem); CloseSelect(); } }>
                                                { elem.sigla } - { elem.name }
                                            </div>
                                        )
                                    })
                                :
                                ShowListDefault(props.list).map((elem, index)=>{
                                    return(
                                        <div className="opt_name" key={ index } onClick={ ()=>{ props.setValue({ "value": elem.id, "label": elem.name, "qtd_project": elem.qtd_project ? elem.qtd_project : 0 }); CloseSelect(); } }>
                                            { elem.name }
                                        </div>
                                    )
                                })
                            }

                            {
                                ( props.type === "country" ? ShowListCountry(props.list).length : ShowListDefault(props.list).length ) === 0 ?
                                    <div className="opt_empty">No results found</div>
                                : null
                            }
                        </div>
                        <div className="all_close_select" onClick={ ()=>{ CloseSelect(); } } />
                    </>
                : null
            }
        </div>
    )
}
